import React from 'react';
import { TrendingUp, Mail } from 'lucide-react';
export const InvestorsSection = () => {
  return <section id="investors" className="py-20 px-4 bg-white" data-id="element-225">
      <div className="max-w-6xl mx-auto" data-id="element-226">
        <div className="text-center mb-16" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-228">
            Investment Opportunities
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-229">
            We're seeking pre-seed and angel investors to join us in
            revolutionizing the tech support industry through AI innovation.
          </p>
        </div>

        <div className="bg-gradient-to-br from-indigo-50 to-slate-50 p-8 rounded-xl border border-indigo-100" data-id="element-230">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-231">
            <TrendingUp className="h-8 w-8 text-indigo-600" data-id="element-232" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-233">
              Partner With Us
            </h3>
          </div>

          <p className="text-gray-600 text-center mb-8 max-w-2xl mx-auto" data-id="element-234">
            Join us in building the future of autonomous tech support. We're
            looking for strategic partners who share our vision of making
            technical support accessible, efficient, and intelligent.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-235">
            <div className="flex items-center gap-3 text-gray-700" data-id="element-236">
              <Mail className="h-6 w-6 text-indigo-600" data-id="element-237" />
              <span className="text-lg font-medium" data-id="element-238">
                For investment inquiries:
              </span>
            </div>
            <a href="mailto:info@TechAIgent.com" className="inline-flex items-center gap-2 bg-indigo-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-indigo-700 transition text-lg" data-id="element-239">
              info@TechAIgent.com
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-240">
            <div data-id="element-241">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-242">
                $50B+
              </div>
              <div className="text-gray-600" data-id="element-243">Global Tech Support Market</div>
            </div>
            <div data-id="element-244">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-245">
                100%
              </div>
              <div className="text-gray-600" data-id="element-246">Autonomous Solution</div>
            </div>
            <div data-id="element-247">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-248">
                24/7
              </div>
              <div className="text-gray-600" data-id="element-249">Always Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};